import React from 'react';
import AppLayout from '@/components/layout/AppLayout';
import Navbar from '@/components/ui/navbar';
import Dashboard from '@/components/dashboard/Dashboard';
// import { useHospital } from '@/hooks/useHospital';

const Home: React.FC = () => {
  return (
    <AppLayout currentPage="Dashboard">
      <Navbar showSearch={false} showAvatar={true} showWelcomeMessage={true} />

      {/* Dashboard Content */}
      <div className="p-6">
        <Dashboard />
      </div>
    </AppLayout>
  );
};

export default Home;
